// extracted by mini-css-extract-plugin
module.exports = {"container":"_99551c8aa8--container--JP0xe"};